import React from 'react'
import { Container } from 'react-bootstrap'

import PageHeadline from '../../../../Components/PageHeadline/PageHeadline'
import Section from '../../../../Components/Section/Section'
import htmlData from './data'
import './extra.css'

function dataGether() {
    return {__html: htmlData.privacyPolicy}
}

const PrivacyPolicyComponent = () => {
    return (
        <div className="privacy-policy-page">
            <PageHeadline>Privacy Policy</PageHeadline>
            <Section>
                <Container>
                    <div className="html-content" dangerouslySetInnerHTML={dataGether()} />
                </Container>
            </Section>
        </div>
    )
}

export default PrivacyPolicyComponent